import { ref } from 'vue'

interface NotificationToastsInstance {
  showSuccess: (text: string, duration?: number) => void
  showError: (text: string, duration?: number) => void
  showInfo: (text: string, duration?: number) => void
  clearToasts: () => void
  removeToast: (id: string) => void
}

// A Vue app-wide toast service
// This will be properly initialized in App.vue when the app is mounted
const toastRef = ref<NotificationToastsInstance | null>(null)

/**
 * Sets the toast component reference
 * @param instance The NotificationToasts component instance
 */
export function setToastRef(instance: NotificationToastsInstance | null) {
  toastRef.value = instance
}

/**
 * Shows a success toast message
 * @param text The message to display
 * @param duration Duration in ms before auto-close
 */
export function showSuccess(text: string, duration = 5000) {
  if (toastRef.value) {
    return toastRef.value.showSuccess(text, duration)
  } else {
    // Fallback to console if toast component is not ready
    console.log(`[Success] ${text}`)
  }
}

/**
 * Shows an error toast message
 * @param text The error message to display
 * @param duration Duration in ms before auto-close (default 15000)
 */
export function showError(text: string, duration = 15000) {
  if (toastRef.value) {
    return toastRef.value.showError(text, duration)
  } else {
    // Fallback to console if toast component is not ready
    console.error(`[Error] ${text}`)
  }
}

/**
 * Shows an info toast message
 * @param text The info message to display
 * @param duration Duration in ms before auto-close
 */
export function showInfo(text: string) {
  if (toastRef.value) {
    return toastRef.value.showInfo(text)
  } else {
    // Fallback to console if toast component is not ready
    console.info(`[Info] ${text}`)
  }
}
